<template>
    <v-app>    
        <v-main>
            <v-container 
                class="fill-height justify-center" 
                fluid
            >
                <v-row 
                    align="center" 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto mx-auto"
                >
                    <v-col >
                        <v-expand-transition>
                            <v-card 
                                v-show="expand"
                                class="elevation-12 mx-auto pa-4"
                                width="400"
                            >
                                <v-row
                                    justify="center"
                                >     
                                    <v-img
                                        src="../../assets/logo.png"
                                        max-width="160"
                                        contain
                                        class="d-flex"
                                    ></v-img>
                                </v-row>

                                <v-row no-gutters>                                    
                                    <v-col cols="12">
                                        <div 
                                            class="pa-4"
                                            v-if="getloginErrors"
                                        >
                                            <v-alert                                                    
                                                type="error"
                                                outlined                                                    
                                                
                                                class="red--text"
                                            >
                                                <div>{{ getloginErrors }}</div>
                                            </v-alert>    
                                        </div>
                                        
                                        <div class="text-h4 text-sm-h5 font-weight-black text-center primary--text mt-4">{{ schoolName }}</div> 
                                        
                                        <v-window v-model="step">
                                            <v-window-item 
                                                :value="1"
                                                transition="slide-x-transition"
                                            >   
                                                <slot name="username"></slot>
                                            </v-window-item>

                                            <v-window-item
                                                :value="2"
                                                transition="slide-x-transition"
                                            >
                                                                                     
                                                <v-card-text>
                                                    <div class='primary--text text-h5 text-center '>Enter Password</div>                                            
                                                </v-card-text>
                                                <slot name="password"></slot>
                                            </v-window-item>

                                            <v-window-item :value="3">

                                                <div class="pa-4">
                                                    <v-alert                                                    
                                                        type="error"
                                                        outlined                                                    
                                                        v-if="resetPasswordErrors"
                                                        class="red--text"
                                                    >
                                                        
                                                    </v-alert>    
                                                </div>

                                                <v-card-text>
                                                    <div class="primary--text text-h5 text-left">Reset Password</div>                                            
                                                </v-card-text>                                            

                                                <!-- Reset Password -->
                                                <v-form 
                                                    class="pa-5"
                                                    @submit.prevent
                                                >
                                                    <v-text-field                                                            
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :type="show ? 'text' : 'password'"
                                                        label="New Password"                                                            
                                                        @click:append="show = !show"                                                    
                                                        name="new-password"
                                                        v-model="formData.newPassword"                                                            
                                                        autofocus
                                                    >
                                                        <v-icon
                                                            slot="prepend"
                                                            color="primary"
                                                        >
                                                            mdi-key
                                                        </v-icon>
                                                    </v-text-field>

                                                    <v-text-field                                                            
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :type="show ? 'text' : 'password'"
                                                        label="Confirm Password"                                                            
                                                        @click:append="show = !show"                                                    
                                                        name="confirm-password"
                                                        v-model="formData.confirmPassword"                                                                                                                       
                                                    >
                                                        <v-icon
                                                            slot="prepend"
                                                            color="primary"
                                                        >
                                                            mdi-key
                                                        </v-icon>
                                                    </v-text-field>
                                                
                                            
                                                    <div class="text-right mt-3 mb-4">                                                
                                                        <v-btn 
                                                            color="primary" 
                                                            @click="changePassword" 
                                                            dark
                                                            block
                                                        >
                                                            CHANGE PASSWORD
                                                        </v-btn>
                                                    </div>
                                                </v-form>

                                            </v-window-item>

                                        </v-window>
                                    </v-col>

                                </v-row>
                            </v-card>
                        </v-expand-transition>
                    </v-col>
                </v-row>

                <v-overlay
                    :value="overlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>

                <v-dialog
                    v-model="dialog"
                    width="500"
                >
                    <v-card>
                        <v-card-title class="text-h5 red lighten-2">
                            <v-icon left color="white">mdi-alert-circle-outline</v-icon>
                            <span class="white--text">Login Error</span>
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-text class="pa-4 text-h6 font-weight-light">
                            Unable to connect to the server. Please check your network connection or contact your administrator.
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn depressed @click="close">
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>               
        </v-main>
        
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    name: 'Login',
    data: () => ({
        //step: 1,
        resetPasswordErrors: false,
        resetPassword: false,
        show: false,
        formData: {
            newPassword: '',
            confirmPassword: '',
        },        
    }),

    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'termReports/getSchoolName',
            primaryColor: 'termReports/getPrimaryColor',
            colorDarken: 'termReports/getColorDarken',
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',
            getUser: 'auth/getUser',
            step: 'auth/getStep',
            overlay: 'auth/getOverlay',
            expand: 'auth/getExpand', 
            dialog: 'auth/getDialog'           
        }),
        getThemeColor(){          
          return 'primary';
        },
        signInClass(){
            return 'primary d-flex pt-4 flex-column justify-center align-center';
        },
       
        icon_color(){
             return 'primary';
        },
        
    },

    
    
    methods: {
        ...mapActions({
            postNewPassword: 'auth/changePassword',
            employee: 'auth/employee',
        }),
        
        ...mapMutations({
            setNewPassword: 'auth/setNewPassword',
            setAuthenticated: 'auth/setAuthenticated',
            setOverlay: 'auth/setOverlay',
            setExpand: 'auth/setExpand',
            setDialog: 'auth/setDialog', 
        }),

        async changePassword(){
            if(!this.formData.newPassword || !this.formData.confirmPassword){
                console.log('passwords blank')
                return;
            }

            if(this.formData.newPassword !== this.formData.confirmPassword){
                console.log('passwords dont match')
                return;
            }

            console.log('changing password...');

            this.setNewPassword(this.formData.confirmPassword);

            try {
                await this.postNewPassword();
                this.setAuthenticated(true);
                sessionStorage.authenticated = true;
                this.setExpand(false);
                await this.employee();
                setTimeout(() => {this.setOverlay(false)})  
                this.$router.replace('/term-reports');
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error)
            }
           
        },
        
        close () {
            this.setDialog(false)
        }
    }
}
</script>

<style scoped>
    .container-background{
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
        /* background: rgb(2,0,36);
        background: linear-gradient(90deg, #4B79A1 , #283E51 ) ; */
    }
       
</style>